export function RequiredMark() {
  return <span className="text-destructive">*</span>;
}
